export const CONTACTS = {
  general: 'contato@akaliai.com.br',
  privacy: 'privacidade@akaliai.com.br',
  website: 'akaliai.com.br',
  app: process.env.REACT_APP_EXTERNAL_APP_URL,
};
